var PathHelper = {};
PathHelper.install = function(Vue) {
  Vue.prototype.publicImagePath = `${process.env.BASE_URL}/img`
  Vue.prototype.assetsImagePath = process.env.VUE_APP_ASSETS_IMAGE_PATH || 'https://assets.symbium.com/images'
}
export default PathHelper;
